var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5437 10C10.9914 10 10.5437 10.4477 10.5437 11V20C10.5437 20.5523 10.9914 21 11.5437 21H20.5437C21.096 21 21.5437 20.5523 21.5437 20V11C21.5437 10.4477 21.096 10 20.5437 10H11.5437ZM8.5437 11C8.5437 9.34315 9.88685 8 11.5437 8H20.5437C22.2006 8 23.5437 9.34315 23.5437 11V20C23.5437 21.6569 22.2006 23 20.5437 23H11.5437C9.88685 23 8.5437 21.6569 8.5437 20V11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5437 3C4.27848 3 4.02413 3.10536 3.83659 3.29289C3.64906 3.48043 3.5437 3.73478 3.5437 4V13C3.5437 13.2652 3.64906 13.5196 3.83659 13.7071C4.02413 13.8946 4.27849 14 4.5437 14H5.5437C6.09599 14 6.5437 14.4477 6.5437 15C6.5437 15.5523 6.09599 16 5.5437 16H4.5437C3.74805 16 2.98499 15.6839 2.42238 15.1213C1.85977 14.5587 1.5437 13.7956 1.5437 13V4C1.5437 3.20435 1.85977 2.44129 2.42238 1.87868C2.98499 1.31607 3.74805 1 4.5437 1H13.5437C14.3394 1 15.1024 1.31607 15.665 1.87868C16.2276 2.44129 16.5437 3.20435 16.5437 4V5C16.5437 5.55228 16.096 6 15.5437 6C14.9914 6 14.5437 5.55228 14.5437 5V4C14.5437 3.73478 14.4383 3.48043 14.2508 3.29289C14.0633 3.10536 13.8089 3 13.5437 3H4.5437Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.20cc9a50.svg";
export { ForwardRef as ReactComponent };